import React from 'react';
import PropTypes from 'prop-types';

import { IconButton, Save01Icon } from '@metarouter-private/mr-mui';

import { useInsertSampleEvent } from '@ion/api';

import WithTooltip from 'app/components/WithTooltip';

import determineTooltipTitle from './determineTooltipTitle';

const DATA_TEST_ID = 'create-sample-event-button';

export default function CreateSampleEventButton({ onClick, disabled = false, disabledMessage, size = 'small' }) {
  const [, { isAllowed: canCreateSampleEvent }] = useInsertSampleEvent();

  const tooltipTitle = determineTooltipTitle({ canCreateSampleEvent, disabled, disabledMessage });
  const isDisabled = disabled || !canCreateSampleEvent;

  return (
    <WithTooltip show={Boolean(tooltipTitle)} title={tooltipTitle}>
      <IconButton onClick={onClick} disabled={isDisabled} data-test-id={DATA_TEST_ID}>
        <Save01Icon fontSize={size} />
      </IconButton>
    </WithTooltip>
  );
}

CreateSampleEventButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  disabledMessage: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
};
